import axios from 'axios';
import {
  COLLECTION_REPORT,
  CUMULATIVE_REPORT,
  D2D_COLLECTION_REPORT,
  DAILY_RUN_REPORT,
  FUEL_CONSUMPTION_REPORT
} from 'src/config/api.config';
import ApiService from './Api.service';

class ReportService extends ApiService {
  getCollectionReport = (params) => {
    return this.doGet(`${COLLECTION_REPORT}`, params, { ...this._headers });
  };

  getDailyRunReport = (params) => {
    return this.doGet(
      `${DAILY_RUN_REPORT}`,
      params,
      { ...this._headers, 'Content-Type': 'text/event-stream' },
      null,
      {
        responseType: 'stream',
        timeout: 0
      }
    );
  };

  getFuelConsumptionReport = (params) => {
    return this.doGet(`${FUEL_CONSUMPTION_REPORT}`, params, {
      ...this._headers
    });
  };

  getCumulativeReport = (params) => {
    return this.doGet(`${CUMULATIVE_REPORT}`, params, {
      ...this._headers
    });
  };

  d2dCollectionReport = (params) => {
    return this.doGet(`${D2D_COLLECTION_REPORT}`, params, {
      ...this._headers
    });
  };
}

export default new ReportService();
